import style from './style';

const SmallIcon = () => {
  return (
    <svg
      width="50"
      className={style.icon}
      height="50"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h50v50H0z" />
        <path
          className={style.theme}
          d="M37.95 17.425h-1v-2.85a.95.95 0 0 0-.95-.95H12.2a.95.95 0 0 0-.95.95v7.9c0 3.65 1.85 6.9 4.65 8.8H8.4a.95.95 0 0 0-.95.95c0 2.3 1.85 4.15 4.15 4.15h24.95c2.3 0 4.15-1.85 4.15-4.15a.95.95 0 0 0-.95-.95H32.3c1.05-.75 1.95-1.65 2.7-2.7h2.95c2.55 0 4.6-2.05 4.6-4.6v-1.95c0-2.55-2.05-4.6-4.6-4.6zm.65 15.8a2.29 2.29 0 0 1-2.05 1.3H11.6c-.9 0-1.65-.55-2.05-1.3H38.6zm-12.4-1.9h-4.25c-4.85 0-8.8-3.95-8.8-8.8v-6.95H35v6.95c0 4.8-3.95 8.8-8.8 8.8zm13.6-7.3c0 1-.85 1.85-1.85 1.85H36.4c.35-1.05.55-2.2.55-3.35v-2.3h1c1 0 1.85.85 1.85 1.85v1.95z"
          fill="#6B4800"
        />
      </g>
    </svg>
  );
};

const MediumIcon = () => {
  return (
    <svg
      width="50"
      className={style.icon}
      height="50"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h50v50H0z" />
        <path
          className={style.theme}
          d="M35.85 14.35H34.2V11.9c0-1.15-1.3-1.95-4.25-2.5-2.3-.4-5.35-.65-8.55-.65-3.2 0-6.35.2-8.65.65-2.95.55-4.25 1.3-4.25 2.5v26.2c0 1.15 1.3 1.95 4.25 2.5 2.3.4 5.35.65 8.55.65 3.2 0 6.25-.25 8.55-.65 2.95-.55 4.25-1.3 4.25-2.5v-2.45h1.65c3.2-.1 5.75-2.6 5.75-5.7v-10c0-3.1-2.55-5.6-5.65-5.6zm-3.6 23.5c-.75.5-4.5 1.45-10.95 1.45-6.45 0-10.2-.9-10.95-1.45v-25.8c.75-.5 4.5-1.45 10.95-1.45 6.45 0 10.2.9 10.95 1.45v25.8zm5.4-7.9c0 1-.8 1.8-1.8 1.8H34.2v-13.6h1.65c1 0 1.8.8 1.8 1.8v10z"
          fill="#6B4800"
        />
      </g>
    </svg>
  );
};

const LargeIcon = () => {
  return (
    <svg
      width="50"
      height="50"
      className={style.icon}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h50v50H0z" />
        <g className={style.theme} transform="translate(7)" fill="#6B4800">
          <path d="M26.979 41.83v-.418c5.345-.501 8.436-5.178 8.436-12.695s-3.174-12.195-8.436-12.696v-4.009a.928.928 0 0 0-.919-.919h-.752c-.584-3.34-3.925-5.011-8.269-5.345l-.417-1.253h-3.425l-.417 1.253c-4.343.418-7.684 2.005-8.269 5.345H1.504a.928.928 0 0 0-.919.919c0 .501.418.919.919.919 1.504 0 2.756 1.253 2.756 2.756V41.83c0 1.503.752 2.84 1.922 3.675L4.01 48.846a.53.53 0 0 0 0 .501c.083.167.25.25.418.25h3.09c.083 0 .25-.083.334-.167l3.174-3.09h10.44l3.174 3.09c.084.084.167.167.334.167h2.172a.457.457 0 0 0 .417-.25.53.53 0 0 0 0-.501l-2.255-3.508c1.003-.835 1.671-2.088 1.671-3.508zm5.262-13.113c0 4.092-.919 8.853-5.262 9.438v-18.96c4.259.585 5.262 5.429 5.262 9.522zM5.096 12.847h8.853v.836H5.597c-.167-.251-.251-.501-.501-.836zm.835 1.921h8.102v4.594H7.1v22.05h.084c.25 1.17 1.253 2.088 2.505 2.088h11.694c1.253 0 2.255-.918 2.505-2.088h.084V19.279h-8.269v-4.594h3.592c.25 0 .501-.251.501-.501 0-.251-.251-.501-.501-.501h-3.592v-.836h9.355v.836h-2.84c-.251 0-.501.25-.501.501 0 .25.25.501.501.501h2.84v27.061a2.639 2.639 0 0 1-2.673 2.673H8.687a2.639 2.639 0 0 1-2.673-2.673V15.604c0-.251 0-.585-.083-.836z" />
          <circle cx="14.868" cy="2.156" r="1.754" />
        </g>
      </g>
    </svg>
  );
};

const LolokIcon = () => {
  return (
    <svg
      width="50"
      height="50"
      className={style.icon}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fill-rule="evenodd">
        <path d="M0 0h50v50H0z" />
        <path
          className={style.theme}
          d="M17.87 20.561c-2.25-1.145-3.747-2.82-3.969-4.708V8.164a58.26 58.26 0 0 1-.928-.173.567.567 0 0 1-.227-1.008l4.984-3.706a12.186 12.186 0 0 1 14.546 0l4.979 3.702a.566.566 0 0 1-.228 1.014c-.308.059-.615.116-.922.17v7.69c-.228 1.936-1.796 3.648-4.141 4.794l2.523 27.065a.531.531 0 0 1-.523.581l-2.074.022-1.354-12.189c-1.266.396-2.817.931-4.033 1.291v11.65a.54.54 0 0 1-.536.536h-2.121a.523.523 0 0 1-.523-.523V37.267c-1.191-.354-2.766-.824-4.03-1.173l-1.357 12.221-2.075-.022a.532.532 0 0 1-.523-.581l2.532-27.151zm3.026 1.098L19.52 34.052l3.803.654V22.059a16.745 16.745 0 0 1-2.427-.4zm8.038.042a17.03 17.03 0 0 1-2.431.374V34.7l3.802-.653-1.371-12.346zM15.659 8.453a62.628 62.628 0 0 0 17.721.135l.001.005c.33-.044.659-.09.988-.14.037 2.248-.024 4.497-.024 6.745 0 0-.06.573-.269 1.092-2.27 5.646-12.226 5.42-16.317 2.283-1.062-.814-1.966-1.969-2.097-3.341-.072-2.258-.015-4.519-.003-6.779z"
          fill="#6B4800"
        />
        <path
          className={style.theme}
          d="M32.59 11.471a.532.532 0 0 0-.833-.436c-.981.69-2.642 1.59-4.85 1.531-4.042-.109-4.578-2.902-9.239-.761a.57.57 0 0 0-.334.519c-.002.802-.003 2.671-.003 2.671.348 2.638 3.689 3.72 6.487 3.961 2.604.225 5.38-.156 7.435-1.838.657-.537 1.207-1.258 1.335-2.1l.002-3.547z"
          fill="#6B4800"
        />
      </g>
    </svg>
  );
};

const Svg = ({ size }) => {
  if (size === 'small') {
    return <SmallIcon />;
  } else if (size === 'medium') {
    return <MediumIcon />;
  } else if (size === 'large') {
    return <LargeIcon />;
  } else {
    return <LolokIcon />;
  }
};

export default Svg;



// WEBPACK FOOTER //
// ./components/icon/index.js